import { generateContext } from '@btime/react-contexts'
import { useFormState } from '@btime/react-hooks'
import { useLoggedUser } from '@btime/react-session'
import React, { useContext, useCallback } from 'react'

import { TO_GROUP, TO_ME, TO_USER } from '../_constants/assignConstants'
import { useServiceOrder } from '../_load/ServiceOrderLoader'

const { StateContext, ActionsContext, Provider } = generateContext()

export const useCloneForm = () => useContext(StateContext)
export const useCloneFormActions = () => useContext(ActionsContext)

export const CloneFormHandler = ({ orderServiceId, ...props }) => {
  const serviceOrder = useServiceOrder()
  const loggedUser = useLoggedUser()

  const [form, handleChange, setForm] = useFormState({
    ...serviceOrder,
    assign: !!serviceOrder.group?.id ? TO_GROUP : TO_USER
  })

  const setAssign = useCallback(
    assign => {
      setForm({ ...form, user: assign === TO_ME ? loggedUser : {}, group: {}, assign })
    },
    [loggedUser]
  )

  return <Provider state={form} actions={{ handleChange, setAssign }} {...props} />
}
